import React, { useState, useEffect, useCallback } from 'react';
import {
    InputAdornment,
    IconButton,
    Snackbar
} from '@material-ui/core';

import {
    Alert
} from '@material-ui/lab';

import FilterContainer from '../../components/FilterContainer';
import DataTable from '../../components/DataTable';
import Loading from '../../components/Loading';
import ActionMenu from '../../components/ActionMenu';
import ConfirmationDialog from '../../components/ConfirmationDialog';

import SearchIcon from '@material-ui/icons/Search';
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';

import Servicos from '../../services/Servicos';
import { useAuth } from '../../AuthContext';

const ListaServicos = (props) => {
    const { user } = useAuth();
    const [data, setData] = useState({
        isLoading: true,
        error: null,
        docs: [],
        page: 0,
        size: 30,
        count: 0
    });

    const [remove, setRemove] = useState({
        open: false,
        name: '',
        id: ''
    });
    const [responseStatus, setResponseStatus] = useState({
        open: false,
        severity: "success"
    })

    const Listar = useCallback((page, size, filter) => {
        Servicos.list(page, size, filter).then(servicos => {
            setData({
                isLoading: false,
                docs: servicos.docs,
                page: servicos.page - 1,
                size: servicos.limit,
                count: servicos.totalDocs
            });
        }).catch(error => {
            setData({
                isLoading: false
            })
            console.log(error);
        });
    }, []);

    useEffect(() => {
        sessionStorage.setItem("@stk/appTitle", "Serviços");
        Listar(data.page, data.size);
    }, [Listar, data.page, data.size]);

    const handleCloseResponseStatus = () => {
        setResponseStatus({
            open: false,
            severity: "success"
        })
    }

    const handleChangePage = (event, newPage) => {
        const { size } = data;
        Listar(newPage, size);
    }

    const handleChangeSize = (event) => {
        Listar(0, +event.target.value);
    }

    const handleClickDelete = (event, id, name) => {
        setRemove({
            open: true,
            name: name,
            id: id
        })
    }

    const handleDeleteServico = (event) => {
        setData({
            ...data,
            isLoading: true
        });

        Servicos.remove(remove.id).then(response => {
            setRemove({
                open: false,
                name: '',
                id: ''
            });

            setResponseStatus({
                open: false
            })

            applyFilters();
        }).catch(error => {
            setData({
                ...data,
                isLoading: false
            });

            setRemove({
                open: false,
                name: '',
                id: ''
            });

            setResponseStatus({
                open: true,
                severity: "error",
                message: (error.message ? error.message : "Ocorreu um problema ao excluir o cadastro. Tente novamente")
            });
        });
    }

    const applyFilters = (searchExpression) => {
        let filters = "";

        if (searchExpression) {
            filters += "&$or[0][nome][$regex]=" + searchExpression;
            filters += "&$or[0][nome][$options]=gi";
        }

        Listar(data.page, data.size, filters);
    }

    const handleKeyUpSearch = (event) => {
        if (event.keyCode === 13) applyFilters(event.target.value);
    }

    const columns = [
        {
            id: 'nome',
            label: 'Nome',
            align: 'left'
        },
        {
            id: 'descricao',
            label: 'Descrição',
            align: 'left'
        },
        {
            id: 'anexo',
            label: 'Exige Anexo',
            align: 'center'
        },
        {
            id: 'valor',
            label: 'Valor',
            align: 'right',
            format: (value) => value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        },
        {
            id: 'id',
            label: 'Ações',
            align: 'center',
            type: 'hybrid',
            format: (doc, index) => (
                <div key={'servicos-' + index} style={{ minWidth: '100px' }}>
                    <IconButton aria-label="Editar" href={'/servicos/' + doc._id} color="primary">
                        {user?.permissoes["Serviços-alterar"] ? (
                            <EditIcon />
                        ) : (
                                <VisibilityIcon />
                            )}
                    </IconButton>
                    {user?.permissoes["Serviços-excluir"] && (
                        <IconButton aria-label="Excluir" onClick={e => handleClickDelete(e, doc._id, doc.nome)} color="secondary">
                            <DeleteIcon />
                        </IconButton>
                    )}
                </div>
            )
        },
    ];

    const filters = [
        {
            type: 'search',
            id: 'search',
            label: 'Filtrar por nome',
            width: 300,
            InputProps: {
                startAdornment: <InputAdornment position="start">
                    <SearchIcon />
                </InputAdornment>,
            },
            onKeyUp: handleKeyUpSearch
        }
    ];

    const handleApplyFilters = () => {
        let searchExpression = document.getElementById("search").value;
        applyFilters(searchExpression);
    }

    const handleDismissFilters = () => {
        document.getElementById("search").value = '';
        applyFilters();
    }

    const { isLoading, docs, page, size, count, error } = data;

    return (!isLoading && docs ?
        <>
            <FilterContainer
                title="Filtros"
                filters={filters}
                handleApplyFilters={handleApplyFilters}
                handleDismissFilters={handleDismissFilters}
            />
            <DataTable
                columns={columns}
                docs={docs}
                page={page}
                size={size}
                count={count}
                error={error}
                handleChangePage={handleChangePage}
                handleChangeSize={handleChangeSize}
            />
            {user?.permissoes["Serviços-incluir"] && (
                <ActionMenu
                    actions={[
                        {
                            icon: <IconButton href="/servicos/new"><DescriptionOutlinedIcon /></IconButton>,
                            title: 'Incluir',
                            type: 'button'
                        }
                    ]}
                />
            )}
            <Snackbar open={responseStatus.open} autoHideDuration={5000} onClose={handleCloseResponseStatus}>
                <Alert elevation={6} variant="filled" onClose={handleCloseResponseStatus} severity={responseStatus.severity}>
                    {responseStatus.message}
                </Alert>
            </Snackbar>
            <ConfirmationDialog
                title="Tem certeza que seja excluir?"
                confirmTitle="Sim"
                confirm={handleDeleteServico}
                cancelTitle="Não"
                cancel={() => {
                    setRemove({
                        ...remove,
                        open: false
                    })
                }}
                open={remove.open}
                onClose={() => {
                    setRemove({
                        ...remove,
                        open: false
                    })
                }}
            >{remove.name}</ConfirmationDialog>
        </>
        :
        isLoading && <Loading open={isLoading} />
    )
}

export default ListaServicos;